import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  RoundPendingIcon,
  Text,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

const HEADER = 'The account information provided already matches an account on file. You are all set!';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
}

export const PlaidDuplicateModal: React.FC<Props> = ({
  visible,
  onSetVisible,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <ModalWrapper testId="PlaidDuplicateModal_modal_wrapper" visible={visible} onSetVisible={onSetVisible}>
      <Box align="center" pad="spacing24">
        <RoundPendingIcon color="warning" />
        <Text
          data-testid="PlaidDuplicateModal_modal_header"
          margin={{ vertical: 'spacing12', bottom: 'spacing24' }}
          textAlign="center"
          size="24px"
          weight={700}
        >
          {t(HEADER)}
        </Text>

        <Box direction="row">
          <AppButton
            testId="PlaidDuplicateModal_modal_submit"
            onClick={onSubmit}
            width="200px"
          >
            {t('Ok')}
          </AppButton>
        </Box>
      </Box>
    </ModalWrapper>
  );
};
